import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Ga4Service } from '@core/services/ga4.service';
import { UrlService } from '@core/services/url.service';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@services/translate.service';
import { selectContextCore } from '@store/context/context.selector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IHotelsAppState } from './../../store/index';
import { MbButton } from '@am/moebius';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'am-error-no-results',
  standalone: true,
  styleUrls: ['./error-no-results.component.scss'],
  templateUrl: './error-no-results.component.html',
  imports: [NgClass, NgTemplateOutlet, MbButton],
})
export class ErrorNoResultsComponent implements OnInit, OnDestroy {
  @Input()
  public appliedFilters: boolean;
  @Input()
  public error: any;
  @Input()
  public locale: string;

  public showError: any;
  public message: string;
  private brands: string[] = ['avantrip'];
  public brandImage: string;
  private unSubscribe$ = new Subject<void>();

  constructor(
    private translateService: TranslateService,
    private store$: Store<IHotelsAppState>,
    private urlService: UrlService,
    private ga4Service?: Ga4Service,
  ) {
    this.store$
      .pipe(select(selectContextCore), takeUntil(this.unSubscribe$))
      .subscribe((context) => {
        if (this.brands.includes(context.brand)) {
          this.brandImage = `no-image-${context.brand}`;
        } else {
          this.brandImage = 'no-image-almundo';
        }
      });
  }

  public ngOnInit() {
    if (this.error) {
      this.generateErrorMessage();
    }
  }

  public generateErrorMessage() {
    this.showError = location.host.split('.').some((str) => /\b(dev|stg|st)\b/.test(str));

    if (this.ga4Service !== undefined) {
      this.ga4Service.error(this.error);
    }

    if (this.error.code) {
      this.message = this.translateService.translate(this.error.code, this.error.message);
    } else {
      this.message = 'Por favor intentá una nueva busqueda.';
    }
  }

  public redirect() {
    this.urlService.redirectCurrency('ARS');
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
